export default __webpack_public_path__ + "static/media/plugged.ef9da48a.svg";